import styled from 'styled-components';
import {themecolors} from "../utils/themecolors";
import trim from "../utils/trim";

const Container = styled.div``;
const Heading = styled.div``;
const Description = styled.div``;
const Image = styled.div``;
const Text = styled.div``;
const Domain = styled.div``;

const LinkExcerpt = styled(({className, data, domain}) => {
    return (
        <Container className={className}>
            {data.large_image &&
                <Image>
                    <img loading="eager"
                        src={`https://media.scored.co/link/${data.large_image}`}/>
                </Image>
            }
            <Text>
                <Heading>
                    {trim(data.title, 128)}
                </Heading>
                <Domain>
                    {domain || ''}
                </Domain>
            </Text>
        </Container>
    );
})`

  background-color: ${({theme}) => theme.color.name === 'dark' ? 'none' : 'initial'};
  border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : themecolors.lighter_border};
  border-radius: 8px;

  ${Text} {
    padding: 12px 16px;
  }
  ${Heading} {
    margin-top: 4px;
    font-weight: 600;
    font-size: 15px;
    overflow: hidden;
    display: -webkit-box;
    //noinspection CssUnknownProperty
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  ${Description} {
    margin-top: 8px;
    font-size: 14px;
    line-height: 21px;
    overflow: hidden;
    display: -webkit-box;
    //noinspection CssUnknownProperty
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  ${Image} {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
    height: 200px;
    flex-shrink: 0;
  }
  ${Image} img {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 200px;
    object-fit: cover;
    width: 100%;
    transform: translateZ(0);
  }
  ${Domain} {
    margin-top: 6px;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_low_impact_text};
    line-height: 23px;
  }
  
  @media only screen and (min-width: 780px) {
    & {
      height: 128px;
      display: flex;
      flex-direction: row;
      background-color: initial;
    }
    ${Text} {
      display: flex;
      flex-direction: column;
    }
    ${Heading} {
      margin-top: 0;
    }
    ${Description} {
      margin-top: 4px;
    }
    ${Image}, ${Image} img {
      width: 128px;
      min-width: 128px;
      height: 128px;
      border-top-right-radius: 0;
      border-bottom-left-radius: 6px;
    }
    ${Domain} {
      margin-top: auto;
    }
  }
`;

export default LinkExcerpt;
